import "./src/styles/index.scss"
import "./src/styles/products.scss"
import "./src/styles/productTemplate.scss"
import "./src/styles/description.scss"
import "./src/styles/header.scss"
import "./src/styles/footer.scss"
import "./src/styles/chat.scss"
import "./src/styles/contact.scss"
import "./src/styles/newsletter.scss"
import "./src/styles/carousel.scss"
import "./src/styles/events.scss"
